export default __webpack_public_path__ + "static/media/RomaFries.f247a0fa.jpg";